// extracted by mini-css-extract-plugin
export default {"emptyText":"TaskList_emptyText__j0GHe"};